import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Avatar, Box } from '@mui/material';

interface RecognitionDialogProps {
  open: boolean;
  onClose: (confirmed: boolean) => void;
  recognition: {
    name: string;
    box: [number, number, number, number];
    student_id: number;
    profile_picture?: string;
    event_id: number;
    attendance_created: boolean;
  } | null;
}

const RecognitionDialog: React.FC<RecognitionDialogProps> = ({ open, onClose, recognition }) => {
  if (!recognition) {
    return null;
  }

  const handleClose = (confirmed: boolean) => {
    onClose(confirmed);
  };

  return (
    <Dialog
      open={open}
      onClose={() => handleClose(false)}
      aria-labelledby="recognition-dialog-title"
    >
      <DialogTitle id="recognition-dialog-title">Confirm Recognition</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: 2 }}>
          <Avatar
            alt={recognition.name}
            src={recognition.profile_picture ? `http://localhost:8000/${recognition.profile_picture.replace(/^\//, '')}` : undefined}
            sx={{ width: 100, height: 100, fontSize: '3rem' }}
          >
            {recognition.name.charAt(0)}
          </Avatar>
          <DialogContentText>
            Are you sure this is <strong>{recognition.name}</strong>?
          </DialogContentText>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)} color="error">
          Reject
        </Button>
        <Button onClick={() => handleClose(true)} color="primary" autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecognitionDialog; 